import { IFrame } from '@proposify/ui';

type Props = {
  videoId: string;
  width: number | string;
  height: number | string;
  title: string;
  autoPlay?: boolean;
};

const VIDYARD_PLAYER_ORIGIN = 'https://play.vidyard.com';
const ALLOWED_ORIGINS = [VIDYARD_PLAYER_ORIGIN];
const PERMISSIONS = ['fullscreen', 'picture-in-picture'] as const;
const AUTOPLAY_PERMISSIONS = ['autoplay', ...PERMISSIONS] as const;

const VidyardEmbed: React.FC<Props> = ({ videoId, width, height, title, autoPlay = false }) => {
  return (
    <div className="video-container" style={{ width, height }}>
      <IFrame
        src={`${VIDYARD_PLAYER_ORIGIN}/${videoId}${autoPlay ? '?autoplay=1' : ''}`}
        allowedOrigins={ALLOWED_ORIGINS}
        title={title}
        sandbox="allow-scripts allow-same-origin"
        allow={autoPlay ? AUTOPLAY_PERMISSIONS : PERMISSIONS}
        width={width}
        height={height}
      />
    </div>
  );
};

export default VidyardEmbed;
